// src/store/rootReducer.js:
import { combineReducers } from "redux";
import chatMssageReducer from "./features/message/messageSlice";
// import socketReducer from "./features/socket/messageSlice";
import textContentReducer from "./features/message/textContentSlice";
import uiReducer from "./features/ui/uiSlice";
// import newSocketReducer from "./features/socket/socketSlice";


const appReducer = combineReducers({
  messages: chatMssageReducer,
  // socket: socketReducer,
  textContent: textContentReducer,
  ui: uiReducer,
  // streaming: newSocketReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
